import authApi from '../../api/auth';

const state = () => ({
    user: null,
    token: null,
    backRoute: null
});

// getters
const getters = {
    user(state) {
        return state.user;
    },
    token(state) {
        return state.token;
    },
    isLoggedIn(state) {
        return !_.isNull(state.user) && !_.isNull(state.token);
    },
    backRoute(state) {
        return state.backRoute;
    }
};

// actions
const actions = {
    socialLogin({commit, state, dispatch}, {token, user}) {
        commit('setUser', user);
        commit('setToken', token);

        return dispatch('loginSuccess');
    },
    login({commit, state, dispatch}, {email, password}) {
        commit('setIsLoading', true, {root: true});
        return authApi.login(email, password).then(data => {
            commit('setUser', data.user);
            commit('setToken', data.token);
            dispatch('loginSuccess');

        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },

    logout({commit, dispatch}) {
        commit('setIsLoading', true, {root: true});
        return authApi.logout().then(() => {
            commit('logout');
            dispatch('logoutSuccess');
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loginSuccess() {
        // [Nick] Firing the event
    },
    logoutSuccess({commit}) {
        // [Nick] Firing the event
    },
    register({commit, state, dispatch}, payload) {
        commit('setIsLoading', true, {root: true});
        return authApi.register(payload).then(data => {
            commit('setUser', data.user);
            commit('setToken', data.token);
            dispatch('loginSuccess');

        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
};

// mutations
const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setToken(state, token) {
        state.token = token;
    },
    logout(state) {
        state.user = null;
        state.token = null;
    },
    rememberBackRoute(state, route) {
        state.backRoute = route;
    },
    forgetBackRoute(state) {
        state.backRoute = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
